import { action, observable } from 'mobx';
import { HttpClient, setMap, DisplayEventProfile } from 'Mri.Web.Common';

export class DisplayEventProfileStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync() {
        const displayEventProfiles = await this.httpClient.get<Mri.DisplayEventProfiles.DisplayEventProfile[]>(
            `/api/v1/display-event-profiles`
        );

        if (displayEventProfiles) {
            setMap(
                this.displayEventProfiles,
                displayEventProfiles.map(dep => new DisplayEventProfile(dep)),
                d => d.displayEventProfileGuid);

        }
    }

    @action
    public async loadAsync(guid: string) {
        const eventProfile = await this.httpClient.get<Mri.DisplayEventProfiles.DisplayEventProfile>(
            `/api/v1/display-event-profiles/${guid}`
        );

        if (eventProfile) this.displayEventProfiles.set(eventProfile.displayEventProfileGuid, new DisplayEventProfile(eventProfile));
    }

    @action
    public async createAsync(model: Mri.DisplayEventProfiles.DisplayEventProfile) {
        const eventProfile = await this.httpClient.post<Mri.DisplayEventProfiles.DisplayEventProfile>(
            `/api/v1/display-event-profiles`,
            model
        );

        if (eventProfile) this.displayEventProfiles.set(eventProfile.displayEventProfileGuid, new DisplayEventProfile(eventProfile));
    }

    @action
    public async updateAsync(guid: string, model: Mri.DisplayEventProfiles.DisplayEventProfile) {
        const eventProfile = await this.httpClient.put<Mri.DisplayEventProfiles.DisplayEventProfile>(
            `/api/v1/display-event-profiles/${guid}`,
            model
        );

        if (eventProfile) this.displayEventProfiles.set(eventProfile.displayEventProfileGuid, new DisplayEventProfile(eventProfile));
    }

    @action
    public async deleteAsync(guid: string) {
        await this.httpClient.delete<Mri.DisplayEventProfiles.DisplayEventProfile>(
            `/api/v1/display-event-profiles/${guid}`
        );

        this.displayEventProfiles.delete(guid);
    }

    @action
    public async applyAsync(model: Mri.DisplayEventProfiles.DisplayEventProfile) {
        const eventProfile = await this.httpClient.put<Mri.DisplayEventProfiles.DisplayEventProfile>(
            `/api/v1/display-event-profiles/apply`,
            model
        );

        if (eventProfile) this.displayEventProfiles.set(eventProfile.displayEventProfileGuid, new DisplayEventProfile(eventProfile));
    }

    @action
    public async infoAsync(model: Mri.DisplayEventProfiles.DisplayEventProfile) {
        return this.httpClient.post<Mri.DisplayEventProfiles.DisplayEventProfileInfo>(
            `/api/v1/display-event-profiles/info`,
            model
        );
    }

    @observable
    public displayEventProfiles = new Map<string, DisplayEventProfile>();

    private readonly httpClient: HttpClient;
}
